export * from './mb-occ-search-page.adapter'
